import React from "react";
import { FlexRowBetween, RespFont } from "../Style";

const FilterBar = ({
  data,
  setProperty,
  property,
  color = "#7b96c4",
  padding = false,
}) => {
  let widthS = window.innerWidth;

  return (
    <FlexRowBetween
      style={{
        width: "min-content",
        border: "2px solid rgba(0, 0, 0, 0.11)",
        borderRadius: "60px",
        padding: widthS > 768 ? "5px" : "3px",
        fontWeight: "700",
        overflowX: "auto",
        margin: "0",
      }}
    >
      {data.map((item, index) => {
        return (
          <RespFont
            key={index}
            psize={"12px"}
            csize={"14px"}
            onClick={() => setProperty(item.name)}
            style={{
              padding: padding
                ? padding
                : widthS > 768
                ? "7px 12px"
                : "3.5px 6px",
              cursor: "pointer",
              width: "max-content",
              background: property === item.name ? color : "inherit",
              transition: "all 0.2s",
              color: property === item.name ? "#fff" : "#3a3c3f",
              borderRadius: "60px",
            }}
          >
            {item.name}
          </RespFont>
        );
      })}
    </FlexRowBetween>
  );
};
export default FilterBar;
